module.exports = __webpack_public_path__ + "static/img/teach.a080ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/teach.png
// module id = jxS+
// module chunks = 1